import React from "react";
import { GoogleAnalyticsContext } from "./google-analytics";
export const useAnalytics = () => {
    const context = React.useContext(GoogleAnalyticsContext);
    if (!context)
        throw new Error("useAnalytics hook must be used inside as GoogleAnalytics provider");
    const { trackEvent } = context;
    return React.useCallback(trackEvent, [trackEvent]);
};
//# sourceMappingURL=use-analytics.js.map